import compose from 'recompose/compose';
import getContext from 'recompose/getContext';
import PropTypes from 'prop-types';
import withProps from 'recompose/withProps';
import { connect } from 'react-redux';

import Shops from '../sidebar/header/shops';
import { changeBarber } from '../auth/actions';
import * as shopSelector from '../auth/selectors';
import {
  getBarbersForSwitcher,
} from '../sidebar/header/selectors';

const mapStateToProps = state => ({
  user: state.auth.user,
  timezone: state.auth.timezone,
  items: getBarbersForSwitcher(state),
  redirectUrl: '/barber/appointments',
  activeName: shopSelector.activeShopNameForBarber(state),
  activeId: shopSelector.getActiveBarberId(state),
});

const mapDispatchToProps = {
  switchItem: barber => changeBarber(barber.id),
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  getContext({
    sidebarActive: PropTypes.bool.isRequired,
  }),
  withProps(props => ({
    collapsed: props.collapsed && !props.sidebarActive,
  }))
)(Shops);
